import { h, Component } from 'preact';
import Asset from '../Asset/Asset';
import { VIEWER_DEFAULTS } from '../../config/defaults';
import { getTransformation } from '../../utils/assetHelpers';
import ScrollListItems from '../ScrollListItems/ScrollListItems';
import { withContext } from '../../common/context';
import { getAltText } from '../../utils/accessibility';
import { ScrollViewerWrapper } from './ScrollViewer.styled';

const INTERSECT_THRESHOLD = 0.5;
const INTERSECT_MAX_MARGIN_PERC = 50;
const calcAssetDimensions = props => {
  let {
    width,
    height,
    context: { config }
  } = props;
  let columns = config.selectDisplayPropsColumns();
  let spacing = config.selectDisplayPropsSpacing();
  let diviedByColumns = value => (value - spacing * (columns - 1)) / columns;
  if (columns > 1) {
    width = diviedByColumns(width);
    height = diviedByColumns(height);
  }

  return { width, height };
};

class ScrollViewer extends Component {
  calculateIntersectMargin = assetHeight => {
    const winHeight = window.innerHeight;
    // Make sure the margin from bottom allows for the threshold value to be
    // achieved according to the asset height ensuring that there's enough
    // space for intersection
    const margin = Math.max(
      Math.max(
        winHeight * (INTERSECT_MAX_MARGIN_PERC / 100),
        winHeight - assetHeight * (INTERSECT_THRESHOLD + 0.3)
      ),
      0
    );
    const marginTop = this.props.context.config.selectDisplayPropsTopOffset();
    const marginBottom = margin - marginTop;

    return `-${marginTop}px 0px -${marginBottom}px 0px`;
  };

  renderAsset = (item, index, viewableItems, setItemRef) => {
    const props = { ...VIEWER_DEFAULTS, ...this.props };
    const selectedAsset = this.props.index;
    const config = props.context.config;
    const inView = selectedAsset <= index && index <= selectedAsset + (viewableItems - 1);
    const columns = config.selectDisplayPropsColumns();
    const spacing = config.selectDisplayPropsSpacing();
    const preloadIntersection = selectedAsset + viewableItems * 1.5 >= index;
    const { width, height } = calcAssetDimensions(props);
    const altText = getAltText(config, item, index, props.items.length);

    // Main view - expanded display
    return (
      <Asset
        {...item}
        focusable
        setRef={setItemRef}
        index={index}
        mediaType={item.mediaType}
        resourceType={item.resourceType}
        width={width}
        columns={columns}
        height={height}
        inView={inView}
        preloadIntersection={preloadIntersection}
        useBreakpoint={true}
        zoom={config.selectZoom()}
        zoomState={this.props.zoomState === index}
        setZoom={props.setZoom}
        spacing={spacing}
        transformation={getTransformation(item.transformation, config)}
        alt={altText}
      />
    );
  };

  render(propsIn) {
    const props = { ...VIEWER_DEFAULTS, ...propsIn };
    const config = props.context.config;
    const columns = config.selectDisplayPropsColumns();
    const { height } = calcAssetDimensions(props);

    return (
      <ScrollViewerWrapper
        data-test="scroll-viewer-wrap"
        borderWidth={config.selectBorderWidth()}
        borderColor={config.selectBorderColor()}
        radius={config.selectRadius()}
      >
        <ScrollListItems
          setSelected={props.setItem}
          itemHeight={height}
          scrollToIndex={props.scrollToIndex}
          items={props.items}
          renderItem={this.renderAsset}
          intersectThreshold={INTERSECT_THRESHOLD}
          intersectionMargin={this.calculateIntersectMargin(height)}
          topOffset={config.selectDisplayPropsTopOffset()}
          columns={columns}
        />
      </ScrollViewerWrapper>
    );
  }
}

export default withContext(ScrollViewer);
